import React from "react";
import PropTypes from "prop-types";
import { Label } from "reactstrap";
import { Field, ErrorMessage } from "formik";

const RavenFormikCheckBoxComp = ({
  name,
  label,
  type,
  divClassName,
  getClassNameValue,
  disabled,
  placeholder,
  checked,
  onChange,
  handleOnChange,
  htmlLabel,
  htmlLabelClick
}) => {


  const htmlLabelText = () => {
    if (htmlLabel)
    {
    return <Label onClick={htmlLabelClick} dangerouslySetInnerHTML={{ __html: label}} />
    }
    else
    {
     return <Label className="form-label" htmlFor={name}>
      {label}
    </Label>
    }
  };

  return (
    <div
      id={name + "_div"}
      className={divClassName || {}}
      style={{ marginTop: "5px" }}
    >
      <Field
        name={name}
        type={type}
        id={name}
        className={getClassNameValue}
        disabled={disabled}
        placeholder={placeholder}
        {...(checked ? { checked: checked } : {})}
        {...(onChange ? { onChange: handleOnChange } : {})}
      />
      <span style={{ marginLeft: "5px" }}>
        { htmlLabelText() }
      </span>
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </div>
  );
};

RavenFormikCheckBoxComp.propTypes = {
  name: PropTypes.any,
  label: PropTypes.any,
  type: PropTypes.any,
  divClassName: PropTypes.any,
  disabled: PropTypes.bool,
  placeholder: PropTypes.any,
  getClassNameValue: PropTypes.any,
  checked: PropTypes.any,
  onChange: PropTypes.any,
  handleOnChange: PropTypes.any,
  htmlLabel: PropTypes.bool,
  htmlLabelClick:PropTypes.any
};

export default RavenFormikCheckBoxComp;
